export const eventsFr = {
    actions: {
        affectFilters: 'Affecter des filtres à ce site',
        affectFiltersTitle: 'Affecter des filtres',
        affectFiltersDevice: 'Confirmer et affecter aux appareils du site'
    },
    api: {
        error: {
            createSite: 'Erreur lors de la création du site {name}',
            deleteSite: 'Erreur lors de la suppression du site {name}',
            fetchSite: 'Erreur lors de la récupération du site',
            fetchSites: 'Erreur lors de la récupération des sites',
            updateSite: 'Erreur lors de la modification du site {name}'
        },
        success: {
            createSite: 'Création du site {name} effectuée avec succès !',
            deleteSite: 'Suppression du site {name} effectuée avec succès !',
            fetchSite: 'Récupération du site effectuée avec succès !',
            fetchSites: 'Récupération des sites effectuée avec succès !',
            updateSite: 'Modification(s) du site {name} effectuée(s) avec succès !'
        }
    },
    createSite: 'Créer un site',
    duplicatedSite: 'Site dupliqué',
    button: {
        addCheckpoint: 'Ajouter un poi',
        duplicateSite: 'Dupliquer'
    },
    poi: {
        name: 'Nom',
        comment: 'Commentaire',
        devicesList: "Liste d'appareils",
        noDetectionFound: 'Aucune détection trouvée',
        noDeviceAssociated: 'Aucun appareil associé'
    },
    detail: {
        informations: {
            informationsTitle: 'Informations',
            siteLocalization: 'Localisation du site',
            partnerConfigTitle: 'Configuration du partenaire',
            partnerConfigUpdate: 'Modification du partenaire'
        },
        pois: {
            poisTitle: 'POIs',
            createCheckpointTitle: 'Créer un nouveau poi',
            partner: 'Partenaire'
        },
        detections: {
            detectionsTitle: 'Détections'
        },
        devices: {
            devicesTitle: 'Appareils'
        }
    },
    detection: {
        table: {
            bib: 'Bib',
            poi: 'POI',
            timestamp: 'Date',
            device: 'Appareil',
            site_filter: 'Site filter',
            timer_filter: 'Timer filter'
        },
        liveDetections: 'Détections en direct',
        pastDetections: 'Détections précédentes'
    },
    filters: {
        archived: 'Archivé',
        clientId: 'ID du client',
        date_limit: 'Date',
        end_at: 'Date de fin',
        endAt: 'Fin du site',
        endDate: 'Date de fin',
        siteName: 'Nom du site',
        field: 'Champ',
        future: 'Futur',
        past: 'Passé',
        period: 'Période',
        showFinished: 'Afficher les sites terminés',
        showOngoing: 'Afficher les sites en cours',
        showUpcoming: 'Afficher les sites à venir',
        finished: 'Sites terminés',
        ongoing: 'Sites en cours',
        upcoming: 'Sites à venir',
        start_at: 'Début du site',
        startAt: 'Début du site',
        startDate: 'Date de début'
    },
    model: {
        clientId: 'ID du client',
        comment: 'Commentaire',
        endAt: 'Date de fin',
        name: 'Nom du site',
        partnerName: 'Partenaire',
        partnerId: 'ID du partenaire',
        startAt: 'Date de début',
        tz: 'Timezone'
    },
    table: {
        clientId: 'ID du Client',
        comments: 'Commentaires',
        startDate: 'Date de début',
        endDate: 'Date de fin',
        siteName: 'Nom du site',
        duplicateSite: 'Êtes-vous sûr(e) de vouloir dupliquer ce site ?'
    },
    title: {
        actionsTitle: 'Actions'
    }
}
